import { render, staticRenderFns } from "./AltaQuitas.vue?vue&type=template&id=e9306a9a"
import script from "./AltaQuitas.vue?vue&type=script&lang=js"
export * from "./AltaQuitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports